const ratingOptions = [
  { key: '1', value: '1', text: '1 – Shumë e dobët' },
  { key: '2', value: '2', text: '2 – Nën pritshmëri' },
  { key: '3', value: '3', text: '3 – Përmbush pritshmëritë' },
  { key: '4', value: '4', text: '4 – Tejkalon pritshmëritë' },
  { key: '5', value: '5', text: '5 – E shkëlqyer' },
]

const recommendOptions = [
  { key: '1', value: 'po', text: 'Po' },
  { key: '2', value: 'jo', text: 'Jo' },
  { key: '3', value: 'ndoshta', text: 'Ndoshta' },
]

const yesNoOptions = [
  { key: '1', value: 'po', text: 'Po' },
  { key: '2', value: 'jo', text: 'Jo' },
]

// Questions 1–4 are shared by both forms
const sharedQuestions = [
  {
    inputName: 'q0',
    name: '1. Si do ta vlerësonit performancën e përgjithshme të punonjësit gjatë periudhës së punësimit?',
    type: 'radio',
    options: ratingOptions,
    required: true,
  },
  {
    inputName: 'q0_comment',
    name: 'Komente',
    type: 'text',
    required: false,
  },
  {
    inputName: 'q1',
    name: '2. Si do ta vlerësonit sjelljen profesionale dhe etikën e punës së punonjësit?',
    type: 'radio',
    options: ratingOptions,
    required: true,
  },
  {
    inputName: 'q1_comment',
    name: 'Komente',
    type: 'text',
    required: false,
  },
  {
    inputName: 'q2',
    name: '3. Cilat janë pikat kryesore të forta të punonjësit? Shto të dhëna si: NPS, Sales apo çfarëdo informatë ndihmëse.',
    type: 'text',
    required: true,
  },
  {
    inputName: 'q3',
    name: '4. Në cilat fusha mendoni se punonjësi ka pasur nevojë për përmirësim?',
    type: 'text',
    required: true,
  },
]

// PROBATION (Përfundimi i fazës testuese)
export const probationQuestions = [
  ...sharedQuestions,
  {
    inputName: 'q4',
    name: '5. A rekomandoni vazhdimin e kontratës?',
    type: 'radio',
    options: recommendOptions,
    required: true,
  },
  {
    inputName: 'q4_comment',
    name: 'Komente (opsionale)',
    type: 'text',
    required: false,
  },
]

// EXIT (Largimi i punonjësit nga kompania)
export const exitQuestions = [
  ...sharedQuestions,
  {
    inputName: 'q5',
    name: '5. A ka ndonjë informatë shtesë që do të ishte i vlefshëm si referencë për një riangazhim të mundshëm në kompani?',
    type: 'text',
    required: false,
  },
  {
    inputName: 'q6',
    name: '6. A ka pasur ankesa të përsëritura nga klientë, kolegë, apo palë tjera lidhur me punonjësin?',
    type: 'radio',
    options: yesNoOptions,
    required: true,
  },
  {
    inputName: 'q6_comment',
    name: 'Komente (opsionale)',
    type: 'text',
    required: false,
  },
]

// RENEWAL (Përfundimi i kontratës / vazhdimi me kontratë të re)
// Shorter form: overall performance (q0), professional behavior (q1),
// and the contract-continuation recommendation (q4). Skips q2/q3.
export const renewalQuestions = [
  ...sharedQuestions.slice(0, 4), // q0, q0_comment, q1, q1_comment
  {
    inputName: 'q4',
    name: '3. A rekomandoni vazhdimin e kontratës?',
    type: 'radio',
    options: recommendOptions,
    required: true,
  },
  {
    inputName: 'q4_comment',
    name: 'Komente (opsionale)',
    type: 'text',
    required: false,
  },
]

export const SURVEY_INTRO = {
  probation:
    'Punonjësi pas një muaji përfundon fazën testuese 6 mujore me kompaninë. Si pjesë e procesit, ju lutemi të jepni vlerësimin tuaj që do të ruhet në profilin në HRM. Ky informacion do të na ndihmojë të vendosim nëse do të vazhdojmë tutje me kontratë të plotë.',
  exit:
    'Punonjësi ka përfunduar marrëdhënien e punës me kompaninë. Si pjesë e procesit të offboarding-ut, ju lutemi të jepni vlerësimin tuaj që do të ruhet në profilin në HRM. Ky informacion do të ruhet për referenca të ardhshme dhe raste të rikthimit.',
  renewal:
    'Punonjësit pas një muaji i skadon kontrata e rregullt e punës. Si pjesë e procesit, ju lutemi të jepni vlerësimin tuaj që do të ruhet në profilin në HRM. Ky informacion do të na ndihmojë të vendosim nëse do të vazhdojmë tutje me kontratë të re.',
}

// Returns the correct question set for a survey type (defaults to probation)
export const getSurveyQuestions = (type) => {
  if (type === 'exit') return exitQuestions
  if (type === 'renewal') return renewalQuestions
  return probationQuestions
}
